<template>
  <section id="intro" class="p-4 md:p-10 leading-tight mb-10">
    <div class="logo mb-2  lg:float-right">
      <a href="https://caseyhouse.com"
        ><img src="@/assets/svg/casey_house_logo.svg" alt="Casey House Logo" id="headerlogo"
      /></a>
    </div>

    <div
      id="introtext"
      class="md:pr-10 text-2xl max-w-full md:text-4xl lg:text-6xl lg:max-w-4xl"
    >
      <p class="mb-10">
        In place of gathering for Art With Heart this year, we’ve been asking
        our community to express their love for Casey House in a drawing or in
        words.
      </p>

      <p class="">
        <router-link href="#print" to="#print"
          >Purchase special edition<svg viewBox="0 0 160 160">
            <path
              class="stroke"
              d="M46.05,45.87A403,403,0,0,0,94.88,96.43c3.43,3,6.91,5.91,10,9.21,2.81,3,5.3,6.21,8,9.25,8.35,9.3,18.77,16.54,27.22,25.74.22.24.46.6.27.87s-.66-.27-.33-.29"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M86.91,31c2,25.19,4.06,50.42,3.61,75.69-.26,14.88-1.39,29.8-.16,44.64l-.51-1.43"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M40.89,142c10.59-10.78,19.89-22.74,29.43-34.46A954.91,954.91,0,0,1,134.89,36"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M36,85.91c20.52-.14,41,.43,61.56,1,6.84.19,13.69.38,20.49,1.17,4.16.49,8.31,1.21,12.49,1.36,3.73.13,7.45-.19,11.17-.16a121.62,121.62,0,0,1,13.06,1.06"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            /></svg
        ></router-link>

        <br />

        <router-link href="#donate" to="#donate" >
          Donate now
          <svg viewBox="0 0 160 160">
            <path
              class="stroke"
              d="M46.05,45.87A403,403,0,0,0,94.88,96.43c3.43,3,6.91,5.91,10,9.21,2.81,3,5.3,6.21,8,9.25,8.35,9.3,18.77,16.54,27.22,25.74.22.24.46.6.27.87s-.66-.27-.33-.29"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M36,85.91c20.52-.14,41,.43,61.56,1,6.84.19,13.69.38,20.49,1.17,4.16.49,8.31,1.21,12.49,1.36,3.73.13,7.45-.19,11.17-.16a121.62,121.62,0,0,1,13.06,1.06"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M40.89,142c10.59-10.78,19.89-22.74,29.43-34.46A954.91,954.91,0,0,1,134.89,36"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M86.91,31c2,25.19,4.06,50.42,3.61,75.69-.26,14.88-1.39,29.8-.16,44.64l-.51-1.43"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
          </svg>
        </router-link>
        <br />

        <router-link href="#draw" to="#draw" >
          Draw a heart
          <svg viewBox="0 0 160 160">
            <path
              class="stroke"
              d="M46.05,45.87A403,403,0,0,0,94.88,96.43c3.43,3,6.91,5.91,10,9.21,2.81,3,5.3,6.21,8,9.25,8.35,9.3,18.77,16.54,27.22,25.74.22.24.46.6.27.87s-.66-.27-.33-.29"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M36,85.91c20.52-.14,41,.43,61.56,1,6.84.19,13.69.38,20.49,1.17,4.16.49,8.31,1.21,12.49,1.36,3.73.13,7.45-.19,11.17-.16a121.62,121.62,0,0,1,13.06,1.06"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M40.89,142c10.59-10.78,19.89-22.74,29.43-34.46A954.91,954.91,0,0,1,134.89,36"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M86.91,31c2,25.19,4.06,50.42,3.61,75.69-.26,14.88-1.39,29.8-.16,44.64l-.51-1.43"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
          </svg>
        </router-link>

        <br  />

        <router-link href="#gallery" to="#gallery">
          See the love
          <svg viewBox="0 0 160 160">
            <path
              class="stroke"
              d="M46.05,45.87A403,403,0,0,0,94.88,96.43c3.43,3,6.91,5.91,10,9.21,2.81,3,5.3,6.21,8,9.25,8.35,9.3,18.77,16.54,27.22,25.74.22.24.46.6.27.87s-.66-.27-.33-.29"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M36,85.91c20.52-.14,41,.43,61.56,1,6.84.19,13.69.38,20.49,1.17,4.16.49,8.31,1.21,12.49,1.36,3.73.13,7.45-.19,11.17-.16a121.62,121.62,0,0,1,13.06,1.06"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M40.89,142c10.59-10.78,19.89-22.74,29.43-34.46A954.91,954.91,0,0,1,134.89,36"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
            <path
              class="stroke"
              d="M86.91,31c2,25.19,4.06,50.42,3.61,75.69-.26,14.88-1.39,29.8-.16,44.64l-.51-1.43"
              style="fill: none"
              stroke="#19324F"
              stroke-width="10"
              stroke-linecap="round"
            />
          </svg>
        </router-link>
      </p>
    </div>



  </section>
</template>

<script>
import ParallaxGallery from '@/components/ParallaxGallery.vue';
import AnimatedButton from "@/components/AnimatedButton.vue";

export default {
  name: "Intro",
  components: {
    // ParallaxGallery
    // AnimatedButton,
  },
  props: ["showDraw"],
  data(){
    return{
      hearts:[]
    }
  },
  methods:{

  }
};
</script>
